import React, { createContext, useContext, useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    let mounted = true;
    api.get("/auth/me")
      .then((r) => mounted && setUser(r.data))
      .catch(() => mounted && setUser(false))
      .finally(() => mounted && setChecking(false));
    return () => { mounted = false; };
  }, []);

  const login = async (email, password) => {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data);
      return { ok: true, user: data };
    } catch (e) {
      const detail = e.response?.data?.detail;
      // Surface real network/CORS errors instead of a generic message so users can
      // tell the difference between bad credentials and a connection problem.
      const error = detail ? formatApiError(detail) : (e.message || "Something went wrong. Please try again.");
      return { ok: false, error };
    }
  };

  const register = async (payload) => {
    try {
      const { data } = await api.post("/auth/register", payload);
      setUser(data);
      return { ok: true, user: data };
    } catch (e) {
      const detail = e.response?.data?.detail;
      const error = detail ? formatApiError(detail) : (e.message || "Something went wrong. Please try again.");
      return { ok: false, error };
    }
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { console.warn("Logout request failed (clearing local state anyway):", e?.message); }
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, checking, login, register, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
